import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import toast from "src/utils/snackbar-notification"
import * as eSignatureService from "./signature.service"


export const loadSignatures = createAsyncThunk("signatures_load", async (userId)=> eSignatureService.getAllSignatureServiceOfCurrentUser(userId))

export const saveSignature = createAsyncThunk("signature_save", async ({signature,userId})=> eSignatureService.createSignature(signature,userId))

export const deleteSignature = createAsyncThunk("signature_delete", async (signatureId)=> eSignatureService.deleteSignature(signatureId))


export const eSignatureSlice = createSlice({
    name:"esignature",
    initialState:{
        signatures:[],
        isLoading:false,
        state:"",
        error:""
    },
    reducers:{
        initSignature:(state,action)=>{
            state.esignature.signatures = [...action.payload]
        },
        removeSignature:(state,action) => {
            const sigPos=state.esignature.signatures.findIndex((esignature)=> esignature.id===action.payload);
            if(sigPos>-1) state.esignature.signatures.slice(sigPos,1);
        },
        addSignatures:(state,action)=>{
            state.esignature.signatures = [...state.esignature.signatures,...action.payload]
        },
    },
    extraReducers:(builder)=>{

        // loading
        builder
        .addCase(loadSignatures.pending, (state,action)=>{
            state.isLoading=true;
            state.state="loading";                     
        })
        .addCase(loadSignatures.fulfilled, (state,action)=>{
            state.isLoading=false;
            state.state="succeeded";           
            state.signatures=[...action.payload.data.data]
                    
        })
        .addCase(loadSignatures.rejected, (state,action)=>{
            state.isLoading=false;
            state.state="failed";  
            state.msg = action?.payload?.data ? action.payload.data.message : action.error.message         
        })

        // create
        builder
        .addCase(saveSignature.pending, (state,action)=>{
            state.isLoading=true;
            state.state="loading";  

        })
        .addCase(saveSignature.fulfilled, (state,action)=>{
            state.isLoading=false;
            state.state="succeeded";     
            state.signatures.push({...JSON.parse(action.payload.config.data),id:action.payload.data.data.signatureID});    
            toast.success("Signature enregistrée.")    
        })
        .addCase(saveSignature.rejected, (state,action)=>{
            state.isLoading=false;
            state.state="failed";  
            state.msg = action?.payload?.data ? action.payload.data.message : action.error.message   
            toast.error(`Signature Error: ${state.msg}`)    

        })

        // delete
        builder
        .addCase(deleteSignature.pending, (state,action)=>{
            state.isLoading=true;
            state.state="loading";           
        })
        .addCase(deleteSignature.fulfilled, (state,action)=>{
            state.isLoading=false;
            state.state="succeeded";     

            const sigPos=state.signatures.findIndex((esignature)=> esignature.id===action.meta.arg);
           
            if(sigPos>-1) state.signatures.splice(sigPos,1);
            toast.success("Signature supprimée.")    

            // state.signatures.push({...JSON.parse(action.payload.config.data),id:action.payload.data.data.signatureID});        
        })
        .addCase(deleteSignature.rejected, (state,action)=>{
            state.isLoading=false;
            state.state="failed";  
            state.msg = action?.payload?.data ? action.payload.data.message : action.error.message;
            toast.error(`Signature Error: ${state.msg}`)    

        })
    }
})

export const {initSignature,removeSignature,addSignatures} = eSignatureSlice.actions;
export default eSignatureSlice.reducer;
